import React from "react";
import styled from "styled-components";

import { palette } from "../ui-components";

const Preloader = ({ className }) => {
  return (
    <Loader className={className}>
      <span className="left-eye"></span>
      <span className="right-eye"></span>
    </Loader>
  );
};

export { Preloader };

const Loader = styled.div`
  width: 10vh;
  height: 10vh;
  border-radius: 50%;
  border: solid 1.3vh ${palette.gray};
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%) rotate(360deg);
  animation: mouthAnimation 3s infinite cubic-bezier(0.455, 0.03, 0.515, 0.955);

  .left-eye,
  .right-eye {
    content: "";
    display: block;
    width: 4vh;
    height: 4vh;
    border-radius: 50%;
    background: ${palette.gray};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    animation: leftEyeAnimation 3s infinite
      cubic-bezier(0.455, 0.03, 0.515, 0.955);
  }

  .left-eye::before {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-left: 2vh solid transparent;
    border-right: 2vh solid transparent;
    border-bottom: 4vh solid ${palette.secondary};
    position: absolute;
    top: -2vh;
    left: 0;
    right: 0;
    z-index: -1;
    animation: markerAnimation 3s infinite
      cubic-bezier(0.455, 0.03, 0.515, 0.955);
  }

  .left-eye::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-left: 2vh solid transparent;
    border-right: 2vh solid transparent;
    border-top: 4vh solid ${palette.secondary};
    position: absolute;
    bottom: -2vh;
    left: 0;
    right: 0;
    z-index: -1;
    animation: markerAnimation 3s infinite
      cubic-bezier(0.455, 0.03, 0.515, 0.955);
  }

  .right-eye {
    animation: rightEyeAnimation 3s infinite
      cubic-bezier(0.455, 0.03, 0.515, 0.955);
  }

  @keyframes mouthAnimation {
    0% {
      transform: translate(-50%, -50%) rotateX(180deg);
      border: solid 1.3vh ${palette.gray};
    }
    10% {
      transform: translate(-50%, -50%) rotateZ(360deg);
      border: solid 1.3vh ${palette.gray};
    }
    40% {
      transform: translate(-50%, -50%) rotateZ(320deg);
      border: solid 1.3vh ${palette.gray};
    }
    60% {
      transform: translate(-50%, -50%) rotateZ(900deg);
      border-right: solid 1.3vh rgba(225, 225, 225, 0);
      border-left: solid 1.3vh rgba(225, 225, 225, 0);
      border-bottom: solid 1.3vh rgba(225, 225, 225, 0);
    }
    100% {
      transform: translate(-50%, -50%) rotateZ(900deg);
      border-right: solid 1.3vh rgba(225, 225, 225, 0);
      border-left: solid 1.3vh rgba(225, 225, 225, 0);
      border-bottom: solid 1.3vh rgba(225, 225, 225, 0);
    }
  }

  @keyframes leftEyeAnimation {
    0% {
      width: 4vh;
      height: 4vh;
      transform: translate(-50%, -50%);
    }
    50% {
      width: 4vh;
      height: 4vh;
      transform: translate(-50%, -50%);
    }
    60% {
      width: 2vh;
      height: 2vh;
      transform: translate(-150%, -50%);
    }
    90% {
      width: 2vh;
      height: 2vh;
      transform: translate(-150%, -50%);
    }
    100% {
      width: 4vh;
      height: 4vh;
      transform: translate(-50%, -50%);
    }
  }

  @keyframes markerAnimation {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    40% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    60% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes rightEyeAnimation {
    0% {
      width: 4vh;
      height: 4vh;
      transform: translate(-50%, -50%);
    }
    50% {
      width: 4vh;
      height: 4vh;
      transform: translate(-50%, -50%);
    }
    60% {
      width: 2vh;
      height: 2vh;
      transform: translate(50%, -50%);
    }
    70% {
      width: 2vh;
      height: 2vh;
      transform: translate(50%, -50%);
    }
    75% {
      width: 2vh;
      height: 2px;
      transform: translate(50%, -50%);
    }
    80% {
      width: 2vh;
      height: 2vh;
      transform: translate(50%, -50%);
    }
    90% {
      width: 2vh;
      height: 2vh;
      transform: translate(50%, -50%);
    }
    100% {
      width: 4vh;
      height: 4vh;
      transform: translate(-50%, -50%);
    }
  }
`;
